import { getBucket, StructuredStore, type StorageMedium, type Store } from '@yp/common/storage.ts';

let bucket: Partial<Record<StorageMedium, Store>> = {};
const stores: Record<string, StructuredStore> = {};

function getStore(key: string, session = false) {
  // DNS: If we fall back, place a warning on the screen about the behavior being limited due to
  // cookies being off.
  const medium = session ? 'sessionStorage' : 'localStorage';
  bucket[medium] ??= getBucket(medium);
  const storeKey = `${medium}.${key}`;
  stores[storeKey] ??= new StructuredStore(bucket[medium], key);
  return stores[storeKey];
}

// Information about the app (e.g. version, install data, etc).
export function metaStore() {
  return getStore('meta');
}

// User preferences to keep local for consistency.
export function prefsStore(session = false) {
  return getStore('prefs', session);
}
